<template>
  <div class="body-container">
    <div style="margin-top: 50px;">

      <div style="background-color: white;">
        <!-- <div>
          <el-input-group style="margin-left: 5%; width: 50%" prepend="搜索">
            <span>找老师：</span>
            <el-input v-model="trainLecturer.name" style="width: 50%" placeholder="老师名称关键字搜索" clearable></el-input>
            <el-button slot="append" icon="el-icon-search" @click="performSearch"></el-button>
          </el-input-group>
        </div> -->
        <div style="margin-left: 50px;">
          <span style="font-size: 18px;padding: 20px">找老师：</span>
          <input v-model="trainLecturer.name" class="CourseSearchBox" type="text" placeholder="老师名称关键字搜索">
          <el-button slot="append" icon="el-icon-search" @click="performSearch"></el-button>
        </div>
        <div style="margin-left: 4%; margin-top: 20px;display: none;">
          <!-- <el-tag>相关行业：</el-tag> -->
          <div style="display: flex;">
            <div style="line-height: 30px;">相关行业：</div>
            <div style="display: flex;">
              <div style="margin-left: 28px" v-for="(item, index) in hangyeList" :key="index">
                <el-button size="small" id="myButton" class="button" @click="xghy(item.dictValue)">{{ item.dictLabel
                  }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-left: 4%; margin-top: 20px;display: none;">
          <!-- <el-tag>相关行业：</el-tag> -->
          <div style="display: flex;">
            <div style="line-height: 30px;">相关专业：</div>
            <div style="display: flex;">
              <div style="margin-left: 28px" v-for="(item, index) in zhuanyeList" :key="index">
                <el-button size="small" id="myButton" class="button" @click="xgzy(item.dictValue)"> {{ item.dictLabel
                  }}</el-button>
              </div>
            </div>
            <br />
          </div>
        </div>

      </div>

      <div style=" background-color: #f6f6f6">
        <div class="mt-title" style="
            margin-left: 2%;
            padding: 10px;
            font-size: 17px;
            font-weight: bold;
          ">
          <p style="">
            相关老师:共有<span id="teacher_number" style="color: #d00e11">{{
              teacherList.length
            }}</span>名老师
          </p>
        </div>
        <div id="teacher_content" v-for="(item, index) in teacherList" :key="index" style="
            margin-top: 10px;
            background-color: white;
            margin-left: 2%;
            margin-right: 2%;
          " class="row course-wrapper course-radius-none mb-30 mobile-pc">
          <div>
            <div class="mobile-pc-box" style="margin-left: 4%; float: left">
              <div class="courses-thumb">
                <img :src="item.pic" prop="image" alt="" style="width: 180px; height: 230px" />
              </div>
            </div>
            <div class="course-main-content clearfix col-12 col-xl-9 col-sm-12 col-lg-9 col-md-9">
              <div class="">
                <div style="display: flex">
                  <a @click="getName(item.id)" prop="name" class="names"
                    style="font-size: 25px; text-decoration: none;cursor: pointer;">{{ item.name }}</a>
                </div>
                <div class="element" style="font-size: 15px; line-height: 2">
                  {{ item.aptitude }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block" style="display: flex;justify-content: center;margin: 10px 0;">
          <!-- <span class="demonstration">完整功能</span> -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="sizes" :page-size="100"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>

  <!-- <div></div> -->
</template>

<script>

export default {
  data() {
    return {
      isClicked: false,
      divStyle: {
        backgroundColor: 'white'
      },
      // form: {
      //   name: this.searchQuery

      // },
      sizes: [5, 10, 15, 20],
      teacherList: [],
      trainLecturer: {
        name: '',
        isDisplay: 1
      },
      currentPage: 1,
      pageSize: 5,
      total: 0, // 假设总共有100项
      zhuanyeList: [],
      hangyeList: []
    };
  },
  // 页面加载的时候调用
  created() {
    this.getHangyeList();
    this.getZhuanyeList();
    this.getTeacherList();

  },

  methods: {
    getRouter() {
      return this.$router.resolve({ name: "specialist" }).href;
    },
    getName(res) {

      this.$router.push({ name: "specialist1", params: { id: res } });
    },
    performSearch() {
      // 在这里执行搜索操作，例如调用一个函数或发送请求
      console.log("搜索关键词:", this.searchQuery);
      this.getTeacherList();

    },
    xghy(a) {
      console.log("相关行业", a);
      this.trainLecturer.contentDetails = a; // 排序方式
      console.log("相关行业", this.trainLecturer);
      this.getTeacherList();

    },
    xgzy(dictValue) {
      this.trainLecturer.pic = dictValue; // 排序方式
      this.getTeacherList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 切换每页显示数量后重置到第一页
      this.getTeacherList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTeacherList();
    },


    //查询老师列表
    getTeacherList() {
      let _this = this;
      let parmas = {
        ..._this.trainLecturer,
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
      };
      _this.$api.lecturerZ
        .getTeacherList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.teacherList = res.rows;
            _this.total = Number(res.total);

          }
        })
        .catch(() => { });
    },

    /** 查询相关行业 */
    getHangyeList() {
      let _this = this;
      let param = {
        dictType: 'related_industry',
      };

      _this.hangyeList = [{
        dictLabel: '全部',
        dictValue: ''
      }]
      _this.$api.system.getDicByCode(param).then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          _this.hangyeList.push(...res.data);
        }
      })
        .catch(() => {
        });
    },

    /** 查询相关专业 */
    getZhuanyeList() {
      let _this = this;
      let param = {
        dictType: 'related_majors',
      };
      _this.zhuanyeList = [{
        dictLabel: '全部',
        dictValue: ''
      }]
      _this.$api.system.getDicByCode(param).then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          console.log("相关专业", res)
          _this.zhuanyeList.push(...res.data);
        }
      })
        .catch(() => {
        });
    },

  },
};
</script>

<style scoped>
.button {
  background-color: #f5f5f5;
  color: #000;
  font-size: 14px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  /* 添加过渡效果 */
  margin-bottom: 10px;
}

.button:hover {
  background-color: #bb0000;
  color: white;
}

.button:active {
  background-color: #bb0000;
  color: white;
}

.CourseSearchBox {
  width: 40%;
  height: 38px;
  font-size: 18px;
  border: 1px solid #CED4DA;
  padding: 8px;
}

.element:hover {
  color: #bb0000;
}

a.names {
  color: #000;
}

a.names:hover {
  color: #bb0000;
}

.block {
  margin-left: 5%;
}

.body-container {
  width: 100%;
  background-color: rgba(164, 171, 189, 0.16);
}

.body-container .ljgd {
  width: 100%;
}

.body-container .ljgd img {
  width: 100%;
}

.body-container .head-box .nav-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 24px;
  margin-left: 250px;
}

.body-container .head-box .nav-box .nav-item {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 18px;
  text-decoration: none;
  cursor: pointer;
  margin-right: 30px;
}

.body-container .head-box .nav-box .nav-item.active {
  color: rgb(64, 112, 179);
  font-weight: 500;
  border-bottom: 3px solid rgb(64, 112, 179);
}

.body-container .head-box .nav-box .nav-item:hover {
  color: rgb(64, 112, 179);
  font-weight: 500;
  border-bottom: 3px solid rgb(64, 112, 179);
  /* transition: all 0.2s; */
}

.body-container .tjkc {
  margin-top: 30px;
  width: 100%;
  height: 800px;
  background-image: url("../../assets/server/courses_bg.png");
}

.body-container .wyzls {
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  height: 800px;
  background-image: url("../../assets/server/teach_bg.png");
}

.form-col-shouye {
  padding-right: 30px;
}

.container {
  display: flex;
  flex-wrap: wrap;

}
</style>



// WEBPACK FOOTER //
// src/view/specialist/index.vue